<template>
    <a-row :gutter="upload? 16: 0">
        <a-col :span="upload? 14: 24">
            <a-list
                    bordered
                    :loading="loading"
                    :dataSource="fileList"
            >
                <template #header>
                        <span>
                            <a href="javascript:void (0)" @click='toHome'>{{rootName || 'Root'}}</a> / </span>
                        <span v-for="(url, index) in urls" :key="index">
                            <span v-if="url"><a href="javascript:void (0)" @click='toFolder(index)'>{{url}}</a> / </span>
                        </span>
                        <FolderAddOutlined v-if="upload" style="cursor: pointer" @click="addFolder" title="新建文件夹"/>

                    <a-input
                            size="small"
                            style="width: 300px;float: right"
                            placeholder="请输入当前目录下的文件名，不区分大小写。"
                            @change="searchUrl"
                    />
                </template>
                <template #renderItem="{item}">
                    <a-list-item>
                        <a-list-item-meta>
                            <template #title>
                            <span v-if="item.dataType === 'folder'">
                                <a-space>
                                    <a-input
                                            placeholder="新建文件夹"
                                            v-if="item.editing" v-model:value="addF.folderName"
                                            @blur="addFolderPost"
                                            @pressEnter="addFolderPost"
                                    />
                                    <span v-else @click="changeFolder(item)" style="cursor: pointer">
                                        <FolderOutlined />
                                        {{ item.file_name }}
                                    </span>
                                    <DeleteOutlined v-if="deleteable" @click="deleteFile(item.url)"/>
                                </a-space>
                            </span>
                                <a v-else @click="selectFile(item)">
                                    <a-space>
                                        {{item.file_name}}
                                        <small v-if="item.description" style="color: #eee">{{item.description}}</small>
                                        <EyeOutlined @click="getDescription(item)"/>
                                        <ContainerOutlined @click="overviewFile(item.url)"/>
                                        <DownloadOutlined v-if="downable" @click="downFile(item.url)"/>
                                        <DeleteOutlined v-if="deleteable" @click="deleteFile( item.url)"/>
                                    </a-space>
                                </a>
                            </template>
                            <a-avatar
                                    src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                            />

                        </a-list-item-meta>
                    </a-list-item>
                </template>
            </a-list>
        </a-col>
        <a-col span="4" v-if="upload">
            <a-textarea
                    v-model:value="description"
                    placeholder="描述文件方便查看"
                    :auto-size="{ minRows: 1, maxRows: 5 }"
            />
            <div style="margin-top: 10px"></div>
            <a-upload-dragger
                    :data="getExtraData"
                    name="files"
                    :action="tcm_api_prefix+ '/tcm/upload/file/'"
                    v-model:fileList="uploadFileList"
                    :multiple="true"
                    @change="handleChangeUpload"
                    style="height: 10px!important;"
            >
                <p class="ant-upload-drag-icon" style="margin-bottom: 0">
                    <inbox-outlined/>
                </p>
                <div>
                    点击或拖拽文件到此处上传<br/>
                    <small>
                        此处支持上传1G以下的文件
                    </small>
                    <br/>
                    <small>
                        超过1G的大文件请用FPT上传
                    </small>
                </div>
            </a-upload-dragger>
        </a-col>
    </a-row>
    <a-modal width="1060px" v-model:visible="modal.visible" title="文件内容" @ok="handleOk">
        <div style=" max-height: 560px;overflow-y: auto;">
            <a-table v-if="modal.isTable" :dataSource="modal.dataSource" :columns="modal.columns" />
            <div v-else style="padding: 10px; background: #eee; border: 1px solid #dedede; border-radius: 4px">
                <SimpleCode :data="modal.fileContent"/>
            </div>
        </div>
    </a-modal>
</template>

<script>
    import { Modal } from 'ant-design-vue';
    import {EyeOutlined, ContainerOutlined, FolderOutlined, DownloadOutlined, DeleteOutlined, FolderAddOutlined} from '@ant-design/icons-vue';
    import {
        new_folder,
        down_file,
        get_file,
        delete_file,
        fileRoot,
        tcm_api_prefix,
        get_file_content,
        compare
    } from "../utils/request";
    import {jy_tip} from "../utils/vue.tool";
    // let isDEV = window.location.hostname.startsWith('192.');
    import SimpleCode from "./SimpleCode";
    export default {
        name: 'FileList',
        props: ['root', 'rootName', 'downable', 'deleteable', 'upload'],
        components: {
            EyeOutlined,
            ContainerOutlined,
            FolderOutlined,
            DownloadOutlined,
            DeleteOutlined,
            FolderAddOutlined,
            SimpleCode
        },
        data() {
            return {
                tcm_api_prefix,
                rootDir: this.root || (fileRoot + 'demos'),
                files: [],
                folders: [],
                descriptions: [],
                loading: true,
                addF: {
                    folderName: '',
                },
                menuData: [
                    {
                        label: '新建文件夹',
                        onClick: ()=>{
                            alert('新建文件夹');
                        }
                    }
                ],
                fileList: [
                    // 初始文件列表，可以从服务器获取
                    {
                        uid: '-1',
                        name: '文件1.png',
                        status: 'done',
                        url: 'http://www.example.com/file1.png',
                    },
                ],
                modal: {}
            };
        },
        created() {
            let {rootDir} = this;
            console.log('rootName', this.rootName);
            // let postfix = ['.tsv'];
            this.getDescriptions();
            this.getFile(rootDir, this.filterRoot);
        },
        methods: {
            handleChange({ fileList }) {
                this.fileList = fileList;
                // 这里可以添加上传文件的逻辑
                // 比如使用ajax上传到服务器
            },
            getDescriptions(){
                get_file_content({dir: this.getFileDir(), file_name: 'description.json'}, (res)=>{
                    let {data} = res;
                    if(data) this.descriptions = data;
                });
            },
            getFile(root_path, filterFunc, func){
                let {rootDir} = this;
                // let postfix = ['.tsv'];
                this.loading = true;
                if(root_path === '') root_path = rootDir;
                get_file({root_path}, (res)=>{
                    let {data} = res;

                    this.loading = false;

                    this.sep = data.sep;
                    if(func) func(res);
                    else{
                        data = data || {folder: [], file: []};
                        if(filterFunc) {
                            console.log('filter', data, filterFunc(data.folder));
                            console.log('folder', this.rootFolder);

                            data.folder = this.rootFolder;
                        }
                        //if(root_path.startsWith(data_root)) root_path = root_path.substring(0, data_root.length);
                        if(root_path.startsWith(rootDir)) root_path = root_path.substring(rootDir.length);
                        let urls = root_path.split(data.sep);
                        this.urls = urls;
                        let {folder, file} = data;
                        file = file.filter(f=>f.file_name !== 'description.json');
                        console.log('file', file);
                        this.fileList = [
                            ...folder.map(f=>{
                                return {dataType: 'folder', ...f}
                            }),
                            ...file.map(f=>{
                                return {dataType: 'file', ...f}
                            }),
                        ];
                        this.folders = folder;
                        this.files = file;

                        console.log(urls);
                    }

                });

            },
            getDescription(item){
                let {file_name, url} = item;
                let {descriptions} = this;
                let {description} = descriptions.find(d=> d.path === url) || {};
                Modal.success({
                    title:  '文件描述: ' + file_name,
                    content: (description || '暂无描述。')
                });
            },
            changeFolder(folder){
                this.getFile(folder.url);
            },
            toFolder(index){
                let {rootDir, urls, sep} = this;
                let root_path =  urls.slice(0, index+1).join(sep);
                root_path = [rootDir, root_path].join(sep);
                console.log(sep, root_path, urls);
                this.getFile(root_path);
            },
            addFolder(){
                let {folders, files} = this;
                //
                folders = [
                    ...folders,
                    {
                        editing: true,
                    }
                ];
                this.folders = folders;
                this.fileList = [
                    ...folders.map(f=>{
                        return {dataType: 'folder', ...f}
                    }),
                    ...files.map(f=>{
                        return {dataType: 'file', ...f}
                    }),
                ];
                console.log('新建文件夹', this.folders);
            },
            addFolderPost(){
                let {addF} = this;
                // 后台创建文件夹folder_name
                let file_dir = this.getFileDir();
                new_folder({file_dir, folder_name: addF.folderName}, (res)=>{
                    let {path, message} = res;
                    if(path) this.getFile(file_dir);
                    else jy_tip(message);
                })
            },
            toHome(){
                // this.getFile('');
                this.getFile('', this.filterRoot);
            },
            selectFile(item){
                console.log(item);
                this.$emit('selectEvent', item);
            },
            filterRoot(data){
                let obj = this;
                return this.$emit('filterRoot', (folder)=> obj.rootFolder = folder, data);
            },
            overviewFile(file_path){
                let postfix = ['.tsv', '.csv'];
                let isTable = postfix.findIndex(p=> file_path.endsWith(p)) > -1;
                get_file_content({file_path, to_string: !isTable, to_json: false}, (res)=>{
                    console.log(res);
                    let {data, message} = res;
                    if(data) {
                        let [ths, ...data1] = data;
                        // let ths = th.split(',');
                        if(Array.isArray(data1)){
                            // data1 = data1.filter(d=>d).map(item=>item.split(','));
                            if(data.length > 0){
                                this.modal.columns = ths.map((key, index)=>{
                                    return {
                                        title: key,
                                        dataIndex: index,
                                        sorter: compare(index)
                                        // sort
                                    }
                                });
                            }
                            this.modal.dataSource = data1;
                        }
                        this.modal.fileContent = data;
                        this.modal.visible = true;
                        this.modal.isTable = isTable;
                    }
                    else jy_tip(message);
                });
            },
            handleOk(){
                this.modal.fileContent = '';
                this.modal.visible = false;
            },
            downFile(file_path){
                down_file({file_path});
            },
            deleteFile(file_path){
                let obj = this;
                delete_file({file_path}, (res)=>{
                    let {message} = res;
                    jy_tip(message);
                    obj.getFile(obj.rootDir);
                });
            },
            handleChangeUpload(info) {
                console.log('upload info==', info);
                const status = info.file.status;
                if (status !== 'uploading') {
                    console.log('upload', status, info.file, info.fileList);
                }
                if (status === 'done') {
                    jy_tip(`${info.file.name} file uploaded successfully.`, 'success');
                    this.getDescriptions();
                    this.getFile(this.getFileDir());
                } else if (status === 'error') {
                    jy_tip(`${info.file.name} file upload failed.`);
                }
            },
            getExtraData() {
                return {
                    // 这里添加你需要传递的其他参数
                    file_dir: this.getFileDir(),
                    description: this.description
                };
            },
            getFileDir(){
                let { rootDir, urls, sep} = this;
                urls = urls || [];
                return  [rootDir, ...urls].join(sep);
            }
        },
    };
</script>